export function getUrlPath(name) {
	return name.replace(/\s+/g, '-').toLowerCase();
}